<spinner *ngIf="loading"></spinner>

<div class="container-fluid" *ngIf="!loading" data-testid="messaging-page">
    <div class="pb-3">
        <h4 class="mb-0">WhatsApp conversation <i class="bi bi-caret-right-fill"></i></h4>
        <!-- Who this conversation belongs to. Shows the phone exactly as the backend supplies it —
             in clear while sensitive-data masking is deactivated platform-wide
             (UNIVAPLAT-2791, Epic UNIVAPLAT-2776). -->
        <div class="text-muted small mt-1" data-testid="messaging-page-subtitle">
            (User ID {{ userId }}<ng-container *ngIf="maskedPhone"> / {{ maskedPhone }}</ng-container>)
        </div>
    </div>

    <!-- Error banner -->
    <div *ngIf="errorMessage" class="alert alert-danger d-flex align-items-center justify-content-between" data-testid="message-log-error">
        <span data-testid="message-log-error-text">{{ errorMessage }}</span>
        <button class="btn btn-sm btn-outline-danger ms-3" (click)="loadMessages()" data-testid="message-log-retry-btn">Retry</button>
    </div>

    <!-- Two-column layout: messages table (left) + conversation panel (right). Stacks on narrow viewports. -->
    <div class="row mt-4">
        <div class="col-12 col-lg-7">
            <!-- Empty state — scoped to the left column so it sits alongside the conversation panel instead of spanning the full page width. -->
            <div *ngIf="!errorMessage && messages.length === 0" class="text-center text-muted py-5" data-testid="messages-empty-state">
                <i class="bi bi-chat-dots fs-1 d-block mb-3"></i>
                No WhatsApp messages have been sent to this customer yet.
            </div>

            <!-- Messages table -->
            <ngx-datatable
                *ngIf="messages.length > 0"
                data-testid="messages-table"
                class="bootstrap"
                [rows]="messages"
                [columnMode]="'force'"
                [headerHeight]="50"
                [rowHeight]="'auto'"
                [footerHeight]="0"
                [messages]="{emptyMessage: 'No messages found', totalMessage: 'messages'}"
                [scrollbarH]="true">

                <ngx-datatable-column prop="userId" name="User ID" [sortable]="false" [width]="80">
                    <ng-template let-row="row" ngx-datatable-cell-template>{{ row.userId }}</ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column prop="maskedPhone" name="Telephone" [sortable]="false" [width]="160">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <app-masked-field [value]="row.maskedPhone" [targetUserId]="row.userId" fieldName="phoneNumber"></app-masked-field>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column prop="sentAt" name="Date" [sortable]="false" [width]="160">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        {{ row.sentAt | date:"dd/MM/yyyy 'at' HH:mm" }}
                    </ng-template>
                </ngx-datatable-column>

                <!-- UNIVAPLAT-1959: show friendly name when available; fall back to SID for legacy rows -->
                <ngx-datatable-column prop="templateName" name="Template" [sortable]="false" [width]="300">
                    <!-- 'Free-text message' is defensive only: the history endpoint now excludes
                         free-text sends (they render in the conversation panel instead), so every
                         row it returns has a templateSid. Kept in case the endpoint's scope
                         changes — an empty cell would look like a data bug. -->
                    <ng-template let-row="row" ngx-datatable-cell-template>{{ row.templateName ?? row.templateSid ?? 'Free-text message' }}</ng-template>
                </ngx-datatable-column>

            </ngx-datatable>

            <!-- Sits below the table (not in the page header) so it reads as an action on this
                 customer's message log. Shown even when the log is empty, since that is exactly
                 when sending the first template matters. -->
            <div class="d-flex pt-5">
                <button class="btn btn-success rounded-pill fw-bold" (click)="openNewMessageModal()" data-testid="new-message-btn">
                    <i class="bi bi-chat-dots"></i> Send approved template
                </button>
            </div>
            <p class="text-muted small fst-italic mt-2 mb-0" data-testid="template-window-note">
                <i class="bi bi-info-circle me-1"></i>
                WhatsApp only allows free-text replies within <strong>24 hours</strong> of the
                customer's last message. Outside that window you can only send a pre-approved
                template, so use this when they haven't messaged recently. This is a WhatsApp
                platform rule, not a Univa restriction.
            </p>
        </div>

        <div class="col-12 col-lg-5 mt-4 mt-lg-0">
            <cdss-admin-whatsapp-conversation
                [userId]="userId"
                (messageSent)="refreshMessages()">
            </cdss-admin-whatsapp-conversation>
        </div>
    </div>
</div>
